import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    width={256}
    height={256}
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <style>{"\n      .cls-1 {\n        fill: #c88242;\n      }\n    "}</style>
    </defs>
    <path
      className="cls-1"
      d="M244.7,112.3c-1.4-6.6-5.2-12.8-9.3-18.4,0,0-13.8-33.5-32.2-44.1-18.4-10.6-71.6-16.5-71.6-16.5-12.7-2.2-46.3,4.7-56.5,7.8-20.4,4.2-33.8,19.8-44.3,36.8-16.9,27.2-23.9,58.9-18.3,89.5,3.2,17.2,12,31.3,26.5,42.6,12.1,9.3,37.6,19.7,46.9,21.3,36.5,6.1,91.9-3.5,91.9-3.5,13.7-4.1,25.8-11.3,37-19.7,13.7-10.2,21.4-24.3,23.5-40,.2-1.2.3-2.5.5-3.7,3.2-10.4,4.6-21.1,5.6-31.9.6-6.7,1.6-13.5.2-20.1ZM137.1,90.1c1.4-1.7,6.5-3.3,8.6-2.9,7.7,1.5,11.7,16.1,3.1,26.5-1.3,1.6-5.5,3.4-7.3,3.2-2.1-.2-5.9-2.7-7-4.6-4.1-7.4-2.7-16.1,2.6-22.2ZM104.8,91.4c1.1-1.7,4.3-4,6.1-4.3,1.8-.3,6.1,1.3,7.4,2.7,5.6,5.8,7.7,14.4,3.1,22.4-1.2,2.1-4.4,4.6-6.3,4.8-1.8.2-5.9-1.3-7.4-2.8-5.7-5.7-7.7-15.3-2.9-22.7ZM83.1,133.2c-1.8-5.7-1.1-12.6,3.6-17,1.9-1.7,8.1-1.5,10.1.1,2.2,1.8,4.7,5.6,6.1,9.7,2.4,7.1-.5,16.9-8.3,17.2-5.9.2-10.1-5.9-11.4-10.1ZM155.7,172c-11.5,13.4-20.9-3.4-37.1,3.8-7,3.2-12.9,1.8-17.4-2.6-4.9-4.8-6.4-13.6-.9-18.7,4.6-4.2,8.9-9.3,10.5-15.2,2.5-9.2,8.3-13.9,16.7-14.1,9-.1,15.4,4.8,17.9,14.4,1.6,6,6.1,11,10.6,15.1,5.3,4.8,3.7,12.6-.3,17.3ZM167.4,141.3c-1.5,1.4-6.9,2.3-8.7,1.5-1.7-.8-4.1-3.4-4.9-5.5-3.2-8-.5-16.4,6.2-21.3,3.8-2.8,9.7-1.1,11.8,3.2,3.7,7.3,2.3,16.2-4.4,22.2Z"
    />
  </svg>
);
export default SVGComponent;
